module.exports = __webpack_public_path__ + "assets/969cd675-2b4c-4baa-ada6-62bb7ace778f.97180b1c.svg";